/**
 * Analytics Constants
 * Centralized event names and tracking configuration
 */

import { AI_EVENTS } from './analytics-events/ai';
import { BILLING_EVENTS } from './analytics-events/billing';
import { CAPTURE_EVENTS } from './analytics-events/capture';
import { CHAT_EVENTS } from './analytics-events/chat';
import { CONNECTOR_EVENTS } from './analytics-events/connectors';
import { EDITOR_EVENTS } from './analytics-events/editor';
import { ENTITY_EVENTS } from './analytics-events/entities';
import { LIVE_EVENTS } from './analytics-events/live';
import { NAVIGATION_EVENTS } from './analytics-events/navigation';
import { ONBOARDING_EVENTS } from './analytics-events/onboarding';
import { PLATFORM_EVENTS } from './analytics-events/platform';
import { PROTOCOL_OBJECT_EVENTS } from './analytics-events/protocol';
import { SHARING_EVENTS } from './analytics-events/sharing';
import { WORKSPACE_EVENTS } from './analytics-events/workspace';

/**
 * Event Names
 * Following [Object] [Action] naming convention
 *
 * THE analytics SSOT (`rules/analytics.md`). Kept as ONE exported
 * object so every call site imports from one place; the events themselves live
 * in `analytics-events/`, split by the sections this file used to carry inline.
 * That split exists because the file hit the 1000-line ceiling enforced by
 * `scripts/check-file-sizes.sh`, where two PRs could each stay under the cap
 * and still redden CI on the merge commit.
 *
 * Adding an event: put it in the module for its section (add a module only for
 * a genuinely new section) and it appears here automatically. Renaming a KEY is
 * a normal refactor; changing a VALUE is not — the strings are the PostHog
 * dashboard contract, so a rename orphans every insight keyed on the old name.
 */
export const ANALYTICS_EVENTS = {
  ...NAVIGATION_EVENTS,
  ...ENTITY_EVENTS,
  ...EDITOR_EVENTS,
  ...AI_EVENTS,
  ...CHAT_EVENTS,
  ...LIVE_EVENTS,
  ...ONBOARDING_EVENTS,
  ...WORKSPACE_EVENTS,
  ...SHARING_EVENTS,
  ...BILLING_EVENTS,
  ...PLATFORM_EVENTS,
  ...PROTOCOL_OBJECT_EVENTS,
  ...CAPTURE_EVENTS,
  ...CONNECTOR_EVENTS,
} as const;

/**
 * PostHog Survey IDs for programmatic display
 */
export const POSTHOG_SURVEYS = {
  QUICK_FEEDBACK: '019ccf98-67d3-0000-667b-86a9babdd34f',
} as const;
